import { Zoom, toast } from "react-toastify";

/**
 * API для c уведомлениями
 */
export default class APIToast {

	static show( isSuccess: boolean, message: string, timeout: number|false = 3 ) {

		const func = isSuccess ? "success" : "error";
		const autoClose = ( !!timeout && !Number.isNaN(timeout) ) ? (timeout * 1000) : false;
		toast[func]( message, {
			position: "top-center",
			autoClose,
			hideProgressBar: true,
			closeOnClick: true,
			className: isSuccess ? "rdc_toast-success" : "rdc_toast-error",
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			transition: Zoom,
			closeButton: false
		});

	};



}
